import { FormFieldTypes, SpecialFormField } from '../types';

export const isSpecialFormField = (
  formField: FormFieldTypes,
): formField is SpecialFormField => formField.type.startsWith('resolve:'); // && 'field_type' in formField;

export const getSpecialFormFieldResolveType = (formField: SpecialFormField) =>
  formField.type.replace(/^resolve:/, '');
